import React, { useState, useEffect, useCallback } from 'react';
import { api, fmtDate, MEAL_LABELS } from '../api';
function RecordModal({ onClose, onSave, initial }) {
  const [form, setForm] = useState(initial || { room_number:'', guest_name:'', meal_type:'breakfast', quantity:1, note:'' });
  const set = (k,v) => setForm(f => ({...f, [k]:v}));
  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal">
        <div className="modal-title">{initial?'Редактировать':'Добавить запись'}</div>
        <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
          <div className="form-row">
            <div className="form-group"><label>Комната</label><input value={form.room_number} onChange={e=>set('room_number',e.target.value)} placeholder="101" /></div>
            <div className="form-group"><label>Тип питания</label>
              <select value={form.meal_type} onChange={e=>set('meal_type',e.target.value)}>
                <option value="breakfast">🍳 Завтрак</option>
                <option value="dinner">🍽 Ужин</option>
                <option value="lunch">🥗 Обед</option>
                <option value="other">☕ Прочее</option>
              </select>
            </div>
          </div>
          <div className="form-group"><label>Гость</label><input value={form.guest_name} onChange={e=>set('guest_name',e.target.value)} placeholder="Иванов Иван" /></div>
          <div className="form-group"><label>Порций</label><input type="number" min="1" max="20" value={form.quantity} onChange={e=>set('quantity',+e.target.value)} /></div>
          <div className="form-group"><label>Примечание</label><input value={form.note||''} onChange={e=>set('note',e.target.value)} placeholder="no-show, поздний выезд..." /></div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Отмена</button>
          <button className="btn btn-primary" onClick={()=>onSave(form)}>Сохранить</button>
        </div>
      </div>
    </div>
  );
}
export default function SessionPage({ user, sessionId, onBack }) {
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState('all');
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [confirming, setConfirming] = useState(false);
  const load = useCallback(async () => {
    try { setData(await api.session(sessionId)); } catch(e) { alert(e.message); } finally { setLoading(false); }
  }, [sessionId]);
  useEffect(() => { load(); }, [load]);
  if (loading) return <div className="empty">Загрузка...</div>;
  if (!data) return <div className="empty">Сессия не найдена</div>;
  const { session, records } = data;
  const isLocked = session.status === 'locked';
  const canEdit = !isLocked || user.role === 'superadmin' || user.role === 'manager';
  const canAddExtra = isLocked && (user.role === 'superadmin' || user.role === 'manager');
  const canConfirm = !isLocked && (user.role==='superadmin'||user.role==='manager');
  const filtered = filter==='all' ? records : records.filter(r=>r.meal_type===filter);
  const byType = (t) => records.filter(r=>r.meal_type===t).reduce((s,r)=>s+r.quantity,0);
  const saveRecord = async (form) => {
    try {
      if (modal==='add') await api.addRecord(sessionId, form);
      else await api.updateRecord(modal.id, form);
      setModal(null); await load();
    } catch(e) { alert(e.message); }
  };
  const deleteRecord = async (id) => {
    if (!window.confirm('Удалить?')) return;
    try { await api.deleteRecord(id); await load(); } catch(e) { alert(e.message); }
  };
  const confirmSession = async () => {
    if (!window.confirm('Подтвердить и закрыть? После этого редактирование будет недоступно.')) return;
    setConfirming(true);
    try { await api.confirm(sessionId); await load(); } catch(e) { alert(e.message); } finally { setConfirming(false); }
  };
  const unlockSession = async () => {
    if (!window.confirm('Разблокировать сессию?')) return;
    try { await api.unlock(sessionId); await load(); } catch(e) { alert(e.message); }
  };
  const STAT_CFG = [
    {t:'breakfast', icon:'🥐', label:'Завтраки', cls:'breakfast'},
    {t:'dinner',    icon:'🌙', label:'Ужины',    cls:'dinner'},
    {t:'lunch',     icon:'🍲', label:'Обеды',    cls:'lunch'},
    {t:'other',     icon:'☕', label:'Прочее',   cls:'other'},
  ];

  return (
    <div className="page">

      {/* Шапка */}
      <div className="card" style={{marginBottom:20,padding:'14px 20px'}}>
        <div style={{display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
          <button className="btn btn-secondary btn-sm" onClick={onBack}>← Назад</button>
          <h2 style={{margin:0,fontSize:20,fontWeight:700}}>{session.hotel_name}</h2>
          <span style={{color:'#636e72',fontSize:14,fontWeight:500}}>{session.date}</span>
          <span className={`status-badge status-${session.status}`}>
            {session.status==='draft'?'Черновик':session.status==='locked'?'🔒 Закрыт':'Подтверждён'}
          </span>
          {session.confirmed_by_name &&
            <span style={{fontSize:12,color:'#b2bec3',marginLeft:'auto'}}>
              Закрыл: {session.confirmed_by_name} · {fmtDate(session.confirmed_at)}
            </span>}
        </div>
      </div>

      {/* Статистика */}
      <div className="stats-row" style={{marginBottom:20}}>
        {STAT_CFG.map(({t,icon,label,cls}) => (
          <div key={t} className="stat-card"
            style={{cursor:'pointer',border:filter===t?'2px solid #0984e3':'2px solid transparent'}}
            onClick={()=>setFilter(filter===t?'all':t)}>
            <div className={`stat-icon ${cls}`}>{icon}</div>
            <div className="stat-body">
              <div className="stat-label">{label}</div>
              <div className="stat-value">{byType(t)}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Тулбар */}
      <div className="card" style={{marginBottom:16,padding:'12px 16px'}}>
        <div style={{display:'flex',gap:10,alignItems:'center',flexWrap:'wrap'}}>
          {session.has_tl_access && canEdit && user.role!=='admin' && (
            <button className="btn btn-secondary" onClick={async()=>{try{await api.sync(session.hotel_id,session.date);await load();}catch(e){alert(e.message);}}}>
              ⚡ Обновить из TL
            </button>
          )}
          {canEdit && !isLocked && <button className="btn btn-success" onClick={()=>setModal('add')}>+ Добавить запись</button>}
          {canAddExtra && <button className="btn btn-warning" onClick={()=>setModal('add')} title="Дозаказ — добавляется к закрытой сессии">➕ Дозаказ</button>}
          <div style={{display:'flex',gap:6,marginLeft:'auto',flexWrap:'wrap'}}>
            <button className={`btn btn-sm ${filter==='all'?'btn-primary':'btn-secondary'}`} onClick={()=>setFilter('all')}>
              Все ({records.length})
            </button>
            {STAT_CFG.map(({t,label})=>(
              <button key={t} className={`btn btn-sm ${filter===t?'btn-primary':'btn-secondary'}`} onClick={()=>setFilter(t)}>
                {label} ({records.filter(r=>r.meal_type===t).length})
              </button>
            ))}
          </div>
          {canConfirm && (
            <button className="btn btn-warning" onClick={confirmSession} disabled={confirming}>
              {confirming?'...':'✅ Подтвердить и закрыть'}
            </button>
          )}
          {isLocked && user.role==='superadmin' && (
            <button className="btn btn-danger btn-sm" onClick={unlockSession}>🔓 Разблокировать</button>
          )}
        </div>
      </div>

      {/* Таблица */}
      <div className="card">
        {filtered.length===0 ? (
          <div className="empty">Записей нет</div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Комната</th><th>Гость</th><th>Питание</th><th style={{textAlign:'center'}}>Кол-во</th>
                  <th>Источник</th><th>Примечание</th><th>Изменил</th>
                  {canEdit && <th></th>}
                </tr>
              </thead>
              <tbody>
                {filtered.map(r=>(
                  <tr key={r.id}>
                    <td><strong>{r.room_number||'—'}</strong></td>
                    <td>{r.guest_name||'—'}</td>
                    <td><span className={`meal-tag meal-${r.meal_type}`}>{MEAL_LABELS[r.meal_type]}</span></td>
                    <td style={{textAlign:'center'}}><strong>{r.quantity}</strong></td>
                    <td><span className={r.source==='tl'?'source-tl':r.source==='extra'?'source-extra':'source-manual'}>{r.source==='tl'?'TL':r.source==='extra'?'Дозаказ':'Ручной'}</span></td>
                    <td style={{color:'#636e72',fontSize:13}}>{r.note||'—'}</td>
                    <td style={{fontSize:12,color:'#b2bec3'}}>{r.updated_by_name||r.created_by_name||'—'}</td>
                    {canEdit && (
                      <td style={{display:'flex',gap:4}}>
                        <button className="btn btn-secondary btn-sm" onClick={()=>setModal(r)}>✏️</button>
                        <button className="btn btn-danger btn-sm" onClick={()=>deleteRecord(r.id)}>🗑</button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {modal && <RecordModal initial={modal==='add'?null:modal} onClose={()=>setModal(null)} onSave={saveRecord} />}
    </div>
  );
}
